import { useMemo } from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

const Details = () => {
  const { geoCountryId } = useNumericParams()

  const pageContext = useMemo(() => ({
    callbacks: {
      updateGeoCountry: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent geoCountryId={geoCountryId} />
    </PageContext.Provider>
  )
}

export default Details
